module.exports = __webpack_public_path__ + "img/pg.98763669.png";